import { ISocialConnection } from '@app/models/SocialConnection'
import { ISocialNetwork } from '@app/models/SocialNetwork'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import './SocialConnection.scss'

export interface ISocialConnectionUIProps {
  className?: string
  socialConnection: ISocialConnection
  style?: React.CSSProperties
}

export interface ISocialConnectionStateProps {
  socialNetwork?: ISocialNetwork
}

type SocialConnectionProps = ISocialConnectionUIProps &
  ISocialConnectionStateProps

export class SocialConnection extends React.PureComponent<
  SocialConnectionProps
> {
  public render() {
    if (!this.props.socialNetwork) {
      return null
    }

    const socialIcon = this._generateSocialIcon(this.props.socialNetwork.name)

    return (
      <div className={this.props.className} style={this.props.style}>
        <FontAwesomeIcon
          className={`social-connection ${this.props.socialNetwork.name.toLowerCase()}`}
          icon={socialIcon}
          fixedWidth
        />
        <a
          className='ml-2'
          href={`/api/SocialNetworks/${this.props.socialNetwork.id}/${
            this.props.socialConnection.username
          }`}
          target='_blank'
          rel='noreferrer'
        >
          {this.props.socialConnection.username}
        </a>
      </div>
    )
  }

  private _generateSocialIcon(name: string) {
    let socialIcon: [IconPrefix, IconName] = ['fab', 'facebook']

    if (name.toLowerCase() === 'linkedin') {
      socialIcon = ['fab', 'linkedin']
    } else if (name.toLowerCase() === 'twitter') {
      socialIcon = ['fab', 'twitter']
    } else if (name.toLowerCase() === 'instagram') {
      socialIcon = ['fab', 'instagram']
    }

    return socialIcon
  }
}
